import Vue from 'vue'

// axios
import axios from 'axios'

const axiosIns = axios.create({
  baseURL: 'http://192.168.0.45:3333/api/v1',
  Authorization: `Bearer ${sessionStorage.getItem('token')}`
  // You can add your headers here
  // ================================
  // baseURL: 'https://some-domain.com/api/',
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})
//axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
Vue.prototype.$http = axiosIns

export default axiosIns
